import React from 'react';
import { useSelector } from 'react-redux';

import { useWizard } from 'ui-components/components/wizard/context';

import { AddFundsButton } from './add-funds-and-create-label-button';
import { ProgressButton } from './progress-button';
import { SubmitButton } from './submit-button';
import { SubmitPaymentInfoButton } from './submit-payment-info-button';
import { US } from '../../../../../../address/countries/US';
import Global from '../../../../../../store/global-selectors';
import { ADD_FUNDS_TAB, PAYMENT_TAB } from '../../../../../utilities/constants';
import { useWalletRegistrationModalContext } from '../../../contexts/wallet-registration-modal-context';

/**
 * @param {object} props
 * @param {boolean} [props.disabled]
 * @param {() => void} props.setWasTermsStepSuccessful
 * @returns {React.ReactElement}
 */
export const PrimaryActionButton = ({ disabled: disabledProp = false, setWasTermsStepSuccessful }) => {
  const { nextStep, canProgress, activeStep } = useWizard();
  const isUSCustomer = useSelector(Global.selectSellerHomeCountry) === US.addressFormat.countryCode;
  const { shouldShowOldTermsTab } = useWalletRegistrationModalContext();

  const disabled = !canProgress || disabledProp;

  // Old flow only: If on Terms tab (next step is Add Funds), show SubmitButton to finish registration
  // In new flow, we skip Terms tab so this condition won't apply from Payment tab
  if (activeStep && activeStep.nextStepId === ADD_FUNDS_TAB && shouldShowOldTermsTab) {
    return <SubmitButton disabled={disabled} setWasTermsStepSuccessful={setWasTermsStepSuccessful} />;
  }

  if (activeStep && activeStep.stepId === PAYMENT_TAB && isUSCustomer) {
    return <SubmitPaymentInfoButton />;
  }

  if (nextStep) {
    return <ProgressButton disabled={disabled} />;
  }

  if (activeStep && activeStep.stepId === ADD_FUNDS_TAB) {
    return <AddFundsButton />;
  }

  return <SubmitButton disabled={disabled} />;
};
